import PageBase from '@glittr/frontend-core/src/core/v2/app/pageBase';
import DataSource from '@glittr/frontend-core/src/core/v2/data/data-source';
import User from '@glittr/frontend-core/src/plugins/auth/user';
import Vue from 'vue';

export default abstract class EventPageBase extends PageBase {
  public get companyName() { return this.companiesDataSource.data?.data.companyName; }

  public get companyId() { return this.companiesDataSource.data?.data.id; }

  public user: User | undefined;

  public companiesDataSource = new DataSource({
    selectCommand: Vue.$service.v2.api.tdg_Companies.getCompanyForUser,
  });

  async loadCompanyDataSource():Promise<void> {
    this.user = await Vue.$auth.getUser();
    if (this.user && this.user.id != null) {
      this.companiesDataSource.filter.userId = this.user?.id;
      await this.companiesDataSource.select();
    }
  }
}
